import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import {CreateBookActivityModal, EditBookActivityModal, BookActivityListFilters } from "@modules/bookActivities/components";

import { useBookActivities } from "./controller";
import { useBookActivitieListColumns } from "./columns";

export const BookActivitiesList = React.memo(() => {
  const {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createBookActivityModalRef,
    editBookActivityModalRef,
    setSelectedRows,
    refetch,
    translate,
  } =  useBookActivities();

  const columns = useBookActivitieListColumns(refetch, translate, editBookActivityModalRef,);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <BookActivityListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="book-activities.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createBookActivityModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateBookActivityModal
        modalRef={createBookActivityModalRef}
        onComplete={refetch}
      
      />
      <EditBookActivityModal
        modalRef={editBookActivityModalRef}
        onComplete={refetch} 
      />
    </List>
  );
});
